import React from 'react';
import { AuthLayout } from '../auth-layout.component';
import { Login } from './login.component';

export const LoginScreen = (): React.ReactElement => {
    return <AuthLayout component={<Login />} />;
};
